package com.merkost.handpass.api.dto.admin

import com.merkost.handpass.api.dto.listing.CreateListingRequest
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AdminCreateListingRequest(
    @SerialName("seller_id") val sellerId: String,
    val listing: CreateListingRequest
)
